// Section1.js
import React from 'react';
import styled from 'styled-components';
import { HiChevronRight, HiOutlineTicket } from 'react-icons/hi2';
import Carrousel from '../../components/Carrousel'
import Section2 from './Section2';

const SectionWrapper = styled.div`
  width: 100%;
  padding: 14px 0 0;
`;

const SorteoCard = styled.section`
  width: min(1280px, calc(100% - 36px));
  margin: 0 auto 20px;
  background: #ffffff;
  border-radius: 20px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  padding: 20px 24px;
`;

const SliderFrame = styled.div`
  width: min(1280px, calc(100% - 36px));
  margin: 0 auto 22px;
`;

const SorteoRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

const SorteoInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
`;

const SorteoIcon = styled.div`
  width: 62px;
  height: 62px;
  border-radius: 16px;
  background: #5ba7af;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const SorteoCopy = styled.div`
  min-width: 0;
`;

const SorteoTitle = styled.h2`
  margin: 0;
  color: #2f3640;
  font-size: clamp(1.7rem, 3.4vw, 2.15rem);
  font-weight: 700;
  line-height: 1.1;
`;

const SorteoText = styled.p`
  margin: 8px 0 0;
  color: #4a5561;
  font-size: clamp(1rem, 1.5vw, 1.15rem);
  font-weight: 500;
  line-height: 1.35;
`;

const SorteoArrow = styled.a`
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: #5ba7af;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  flex-shrink: 0;
  transition: background-color 0.2s ease, transform 0.15s ease;

  &:hover {
    background: #4d939b;
    transform: translateX(2px);
    color: #ffffff;
  }
`;

const Section1 = () => {
  return (
    <SectionWrapper>
      <SorteoCard aria-label="Último sorteo">
        <SorteoRow>
          <SorteoInfo>
            <SorteoIcon aria-hidden>
              <HiOutlineTicket size={34} />
            </SorteoIcon>
            <SorteoCopy>
              <SorteoTitle>Último sorteo aquí</SorteoTitle>
              <SorteoText>Resultados actualizados para nuestros sorteos</SorteoText>
            </SorteoCopy>
          </SorteoInfo>
          <SorteoArrow
            href="https://juj.lotemovil.com.ar/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Ir a LoteMovil Jujuy"
          >
            <HiChevronRight size={30} />
          </SorteoArrow>
        </SorteoRow>
      </SorteoCard>
      <SliderFrame>
        <Carrousel />
      </SliderFrame>
      <Section2 />
    </SectionWrapper>
  );
};

export default Section1;